<template>
  <div class="section" id="liveScheduleRegistration">
    <div class="title">配信予定確認/編集</div>
    <div class="columns">
      <div class="column">
        <p class="headline">配信スケジュール</p>

        <p class="description">配信の開始日時を設定します。</p>
        <b-datetimepicker
          class="datetimepicker_schedule"
          locale="ja-JP"
          v-model="startAt"
          :min-datetime="minDatetime"
          :disabled="!allowScheduleInput"
        >
          <template #left>
            <b-button
              label="Now"
              type="is-primary"
              icon-left="clock"
              @click="startAt = new Date()"
            />
          </template>

          <template #right>
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="startAt = null"
            />
          </template>
        </b-datetimepicker>

        <p class="description spacer">配信の終了日時を設定します。</p>
        <b-datetimepicker
          class="datetimepicker_schedule"
          locale="ja-JP"
          v-model="endAt"
          :min-datetime="minDatetime"
          :disabled="!allowScheduleInput"
        >
          <template #left>
            <b-button
              label="Now"
              type="is-primary"
              icon-left="clock"
              @click="endAt = new Date()"
            />
          </template>

          <template #right>
            <b-button
              label="Clear"
              type="is-danger"
              icon-left="close"
              outlined
              @click="endAt = null"
            />
          </template>
        </b-datetimepicker>

        <p class="headline spacer">限定配信日時</p>

        <p class="description">限定配信の時間を設定します。</p>
        <div class="reservearea">
          <b-datetimepicker
            class="datetimepicker_reserve"
            locale="ja-JP"
            v-model="reserveStartAt"
            :min-datetime="minDatetime"
            :disabled="!allowReserveInput || reserved || reserverCount > 0"
          >
            <template #left>
              <b-button
                label="Now"
                type="is-primary"
                icon-left="clock"
                @click="reserveStartAt = new Date()"
              />
            </template>

            <template #right>
              <b-button
                label="Clear"
                type="is-danger"
                icon-left="close"
                outlined
                @click="reserveStartAt = null"
              />
            </template>
          </b-datetimepicker>
          <p>〜</p>
          <b-datetimepicker
            class="datetimepicker_reserve"
            locale="ja-JP"
            v-model="reserveEndAt"
            :min-datetime="minDatetime"
            :disabled="!allowReserveInput || reserved || reserverCount > 0"
          >
            <template #left>
              <b-button
                label="Now"
                type="is-primary"
                icon-left="clock"
                @click="reserveEndAt = new Date()"
              />
            </template>

            <template #right>
              <b-button
                label="Clear"
                type="is-danger"
                icon-left="close"
                outlined
                @click="reserveEndAt = null"
              />
            </template>
          </b-datetimepicker>
        </div>

        <p class="headline spacer">配信タイトル</p>
        <input class="title_input" type="text" v-model="title"/>

        <p class="headline spacer">サムネイル登録</p>
        <div class="thumbnail">
          <figure class="image thumbnail__image">
            <b-image :src="previewImageUrl" ratio="400by255" />
          </figure>
          <b-field label="">
            <b-upload @input="onFileChanged" drag-drop expanded>
              <div class="content has-text-centered preview__upload">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your files here or click to upload</p>
              </div>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
    <ReserveList :liveId="values.liveId" @reserverCount="setReserverCount" isCast />
    <div class="buttons">
      <b-button class="button cancel" @click.native="cancel">
        キャンセル
      </b-button>
      <b-button
        class="button submit"
        @click.native="submitLiveSchedule"
        :loading="sending"
      >
        変更する
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ReserveList from '@/components/ReserveList';
import * as reserveServices from '@/services/reserveServices';
import liveScheduleMixin from '@/mixins/liveScheduleMixin'

export default {
  name: 'LiveScheduleRegistration',
  mixins: [liveScheduleMixin],
  props: {
    values: Object
  },
  components: {
    ReserveList
  },
  data() {
    return {
      startAt: null,
      endAt: null,
      reserveStartAt: null,
      reserveEndAt: null,
      title: null,
      imageFile: null,
      previewImageUrl: null,
      minDatetime: moment().toDate(),
      sending: false,
      reserved: false,
      reserverCount: 0
    };
  },
  async created() {
    this.loadLive();
  },
  methods: {
    async loadLive() {
      if (!this.values.liveId) {
        this.cancel();
        return;
      }
      await this.$store.dispatch('live/loadUpComingLive',
        this.values.liveId
      );

      const upComingLive = this.$store.state.live.upComingLive;
      this.startAt = upComingLive.startAt;
      this.endAt = upComingLive.endAt;
      this.reserveStartAt = upComingLive.reserveStartAt;
      this.reserveEndAt = upComingLive.reserveEndAt;
      this.previewImageUrl = upComingLive.thumbnailURL;
      this.title = upComingLive.title;

      //this.reserved = await this.checkReserved();
    },
    async submitLiveSchedule() {
      if (this.sending) return;

      let validateResult = await this.validate();
      if (!validateResult) {
        return;
      }

      let checkResult = await this.checkAllowReserveChange();
      if (!checkResult) {
        return;
      }

      try {
        this.sending = true;

        let doc = {
          id: this.values.liveId,
          userId: this.$store.state.auth.uid,
          startAt: this.startAt,
          endAt: this.endAt,
          reserveStartAt: this.reserveStartAt,
          reserveEndAt: this.reserveEndAt,
          title: this.title,
          imageFile: this.imageFile,
          thumbnailURL: this.previewImageUrl
        };

        await this.$store.dispatch('live/updateUpComingLive', doc);

        if (doc.reserveStartAt && doc.reserveEndAt) {
          await reserveServices.createReserveDoc(this.values.liveId, doc.reserveStartAt, doc.reserveEndAt)
        }

        this.sending = false;

        this.$emit("action", {
          menu: "liveSchedule"
        })
      } catch (err) {
        this.sending = false;
        console.error(err);
        throw err;
      }
    },
    cancel() {
      this.$emit("action", {
        menu: "liveSchedule"
      })
    },
    setReserverCount(count) {
      this.reserverCount = count;
    },
    onFileChanged(inputFile) {
      this.imageFile = inputFile;
      this.previewImageUrl = URL.createObjectURL(inputFile);
    },
    async checkAllowReserveChange() {
      const upComingLive = this.$store.state.live.upComingLive;
      if (!upComingLive) {
        return true;
      }

      let reserveStartAt = upComingLive.reserveStartAt;
      let reserveEndAt = upComingLive.reserveEndAt;

      if (reserveStartAt == this.reserveStartAt && reserveEndAt == this.reserveEndAt) {
        return true;
      }

      if (await this.checkReserved()) {
        this.$buefy.toast.open({
          duration: 3000,
          message: "既に限定配信予約があるため、限定配信日時は変更出来ません。",
          type: 'is-danger'
        });
        return false;
      }
      return true;
    },
    async checkReserved() {
      let list = await reserveServices.getReserve(this.values.liveId);
      for (let item of list) {
        if (item.reserver) return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-schedule-registration.scss';
</style>
